export enum KeyboardSymbolKind {
  Number = 'Number',
  Backspace = 'Backspace',
  Enter = 'Enter',
  Comma = 'Comma',
  Clear = 'Clear',
  ModeToggle = 'ModeToggle',
}
